import axios from '../../../libs/axios';
export const login = data => {
  return axios.post('/3585eb89-060b-4f0d-8d43-eab6975d695e/login', data);
};